import React, { useState } from 'react'
import { Link } from "@StarberryUtils"
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation } from "@reach/router"
import SendFriendForm from '@Components/forms/sendfrnd-form';
import Modal from "react-bootstrap/Modal"
// import $ from 'jquery/dist/jquery.min.js'
// import SendFriendForm from '@Components/forms/sendfrnd-form';
import { Share } from '@Components/icon/icon';

import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton
}
    from "react-share";
import {
    EmailIcon,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon
} from "react-share"

const SocialShare = (props) => {
	    const [Shareicons, setShareicons] = React.useState(false);
	    const location = useLocation();
    	const shareUrl = location.href
		const openShareicons = () => {
            setShareicons(!Shareicons)
	    }
	  const [show, setShow] = useState(false);

	  const handleClose = () => setShow(false);
      const handleShow = (event) => {   
        setShow(true);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Share - social icons',
          'formType': event + ' - ' +shareUrl,
          'formId': 'Share',
          'formName': 'Share',
          'formLabel': 'Share'
        });   
    }
      const trackerShare = (event) => {    
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'Share - social icons',
          'formType': event + ' - ' +shareUrl,
          'formId': 'Share',
          'formName': 'Share',
          'formLabel': 'Share'
        });    
    }



	    return (props.propDetails ? 
            
            <div className="share-fet">
                                                        {props.isMob ? <a onClick={openShareicons} className="icons">
                                             <i className="icon-share">

                                             </i>
                                        </a> :
            <a onClick={openShareicons}  href="javascript:void(0)" className="like">
                                            <i className="icon-share">
                                            </i>
                                            <span className="sm-text">
                                                Share
                                        </span>
                                        </a>}
            {/* <a onClick={openShareicons}  href="javascript:void(0)" className="btn-share share">
                  <Share /> <span>{props.Title}</span> */}
                  {Shareicons &&
        <div className="hover-share">
            <FacebookShareButton onClick={()=>trackerShare('FacebookShareButton')} url={shareUrl} className="my-share-button facebook-share">
                <FacebookIcon size={32} round={false} borderRadius={`10`} />
            </FacebookShareButton>
            <TwitterShareButton onClick={()=>trackerShare('TwitterShareButton')} url={shareUrl} className="my-share-button twitter-share">
                <TwitterIcon size={32} round={false} borderRadius={`10`} />
            </TwitterShareButton>
            <LinkedinShareButton onClick={()=>trackerShare('LinkedinShareButton')} url={shareUrl} className="my-share-button linked-share">
                <LinkedinIcon size={32} round={false} borderRadius={`10`} />
            </LinkedinShareButton>

            <WhatsappShareButton onClick={()=>trackerShare('WhatsappShareButton')} url={shareUrl} className="my-share-button whatsapp-share">
                <WhatsappIcon size={32} round={false} borderRadius={`10`} />
            </WhatsappShareButton>
            <EmailShareButton onClick={()=>handleShow('SendToFriend')} className="my-share-button email-share">
                <EmailIcon size={32} round={false} borderRadius={`10`} />
            </EmailShareButton>
        </div>
    }
		
          <Modal
              id="share_modal_mobile"
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              size="lg"
       		 dialogClassName="modal-90w modal-form"
            >
              <Modal.Header closeButton className="contact-close-btn memberPopup">
                <Modal.Title className="w-100"><h6 className="text-center content-primary-color mb-0 text-uppercase">Share to a Friend</h6></Modal.Title>
              </Modal.Header>
              <Modal.Body>
			  <SendFriendForm property_id={props.data?.id} page_url={shareUrl} property_title={props.data?.title ? props.data?.title : ''} property_img={props.data?.images && props.data?.images.length > 0 ? props.data?.images[0].url : ''} property_address={props.data?.display_address ? props.data?.display_address : ''} property_bedrooms={props.data?.bedroom ? props.data?.bedroom : ''} property_bathrooms={props.data?.bathroom ? props.data?.bathroom : ''} />

              </Modal.Body>
            </Modal>      
            </div>
            : 
            props.iconshare ? 
            <>
        <div onClick={openShareicons}  href="javascript:void(0)" className="icon-social bottom-social-blk">
                                            {/* <i className="icon-share">
                                            </i> */}

                                        <span className="sm-text right-increase d-md-flex">
                                            Share
                                    </span>
                                    <div className="icon-social">
                                        <TwitterShareButton onClick={()=>trackerShare('TwitterShareButton')} url={shareUrl}>
                                            <i className="icon-twitter">

                                            </i>
                                        </TwitterShareButton>
                                    </div>
                                    <div className="icon-social">
                                        <FacebookShareButton onClick={()=>trackerShare('FacebookShareButton')} url={shareUrl}>
                                            <i className="icon-fb">

                                            </i>
                                        </FacebookShareButton>
                                    </div>
                                    <div className="icon-social">
                                        <LinkedinShareButton onClick={()=>trackerShare('LinkedinShareButton')} url={shareUrl}>
                                            <i className="icon-linkedln">

                                            </i>
                                        </LinkedinShareButton>
                                    </div>
                                    </div>
                                    {/* {Shareicons && <> */}
                                   
                                    {/* </>} */}
                                    {/* <div className="icon-social">
                                        <Link >
                                            <i className="icon-file">

                                            </i>
                                        </Link>
                                    </div> */}
		
        </>
             :
	    	<>
            <div className="social-share-blkk" >
        <div onClick={openShareicons}  href="javascript:void(0)" className="icon-social filz">
                                            <i className="icon-share">
                                            </i>

                                        <span className="sm-text d-md-flex">
                                            Share this post
                                    </span>
                                    </div>
                                    {Shareicons && <div className="hover-share">
                                    <FacebookShareButton onClick={()=>trackerShare('FacebookShareButton')} url={shareUrl} className="my-share-button facebook-share">
                <FacebookIcon size={32} round={false} borderRadius={`10`} />
            </FacebookShareButton>
            <TwitterShareButton onClick={()=>trackerShare('TwitterShareButton')} url={shareUrl} className="my-share-button twitter-share">
                <TwitterIcon size={32} round={false} borderRadius={`10`} />
            </TwitterShareButton>
            <LinkedinShareButton onClick={()=>trackerShare('LinkedinShareButton')} url={shareUrl} className="my-share-button linked-share">
                <LinkedinIcon size={32} round={false} borderRadius={`10`} />
            </LinkedinShareButton>

            <WhatsappShareButton onClick={()=>trackerShare('WhatsappShareButton')} url={shareUrl} className="my-share-button whatsapp-share">
                <WhatsappIcon size={32} round={false} borderRadius={`10`} />
            </WhatsappShareButton>
                                    </div>}
                                    </div>
		
        </>
)

}
export default SocialShare